import { ChangeEvent, FC } from 'react';
import { Box, TextField, Typography } from '@material-ui/core';
import { ErrorMessage, Field } from 'formik';
import { useStyles } from '../../styles';

interface Props {
    value: number | null;
    setFieldValue: (fieldName: string, value: string) => void;
    maximumTicketsNumber: number;
}

const TicketsNumberField: FC<Props> = ({ value, setFieldValue, maximumTicketsNumber }) => {
    const classes = useStyles();

    return (
        <Box className={classes.row}>
            <Typography className={classes.label}>Number of tickets</Typography>
            <Field
                type="number"
                placeholder={`Max ${maximumTicketsNumber}`}
                component={TextField}
                autoComplete="off"
                variant="outlined"
                value={value || ''}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    if (parseInt(event.target.value || '0', 10) <= maximumTicketsNumber)
                        setFieldValue('tickets', event.target.value);
                }}
                InputProps={{
                    name: 'tickets',
                    classes: { root: classes.field, input: classes.centeredField },
                }}
                fullWidth
            />

            <p className={classes.errorText}>
                <ErrorMessage name="tickets" />
            </p>
        </Box>
    );
};

export default TicketsNumberField;
